import type { PartnerLocation } from '@dru/types';

/**
 * The branches worth offering at booking.
 *
 * A partner registered since 14 Oct 2026 gets a primary "MAIN" branch made
 * from its registration address, which is the registered site itself. The
 * pickers already offer "Registered site", so listing MAIN too would show
 * the same place twice; only the other branches are choices.
 */
export function otherBranches(items: PartnerLocation[] | undefined): PartnerLocation[] {
  return (items ?? []).filter((b) => !(b.isPrimary && b.code === 'MAIN'));
}
